export const vaultPages = {
  vault: () => import('./pages/VaultPage'),
};
